import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { setInitialAuthState } from "../redux/actions/auth_action";
import TopNav from "../common/shared/TopNav";
import { isValidToken } from "../utils/authUtils";

function ProctectedRoutes({ userData }) {
  // const isAuthenticated = useMemo(() => {
  //   return (userData, accessToken) => {
  //     return userData && accessToken;
  //   };
  // }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Safely read token from localStorage
  const accessToken = useMemo(() => {
    try {
      const raw = localStorage.getItem("profile");
      if (!raw) return null;
      return JSON.parse(raw)?.token ?? null;
    } catch {
      return null;
    }
  }, []);

  const isJwt = accessToken?.split(".").length === 3;
  const isAuthed = isJwt ? isValidToken(accessToken) : Boolean(accessToken);

  useEffect(() => {
    if (!isAuthed) {
      dispatch(setInitialAuthState(navigate));
    }
  }, [isAuthed, dispatch, navigate]);

  // const token = localStorage.getItem("profile");
  // const accessToken = JSON.parse(token)?.token;

  // useEffect(() => {
  //   if (!isAuthenticated(accessToken, accessToken)) {
  //     dispatch(setInitialAuthState(navigate));
  //   }
  // }, [dispatch, navigate, userData, accessToken, isAuthenticated]);

  return isAuthed ? (
    <div className="bg-[#f5f5f5]">
      <TopNav />
      <main className="min-h-screen h-full pb-[5rem] ">
        <Outlet />
      </main>
    </div>
  ) : (
    <Navigate to="/" replace />
  );
}

export default ProctectedRoutes;
